import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const ListHeader = ({ title, link }) => {
  return (
    <li style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "22px 16px 8px",
      listStyle: "none",
    }}>
      <span style={{
        borderLeft: "3px solid #1a73e8",
        paddingLeft: "10px",
        fontSize: "0.78rem",
        fontWeight: 800,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        color: "#424242",
      }}>
        {title}
      </span>
      {link && (
        <Link to={link} style={{ color: "#bdbdbd", lineHeight: 1, textDecoration: "none" }}>
          <FontAwesomeIcon icon={faCog} style={{ fontSize: "0.75rem" }} />
        </Link>
      )}
    </li>
  );
};

export default ListHeader;
